/** @format */
import React from 'react';
import styled from 'styled-components';

import { SortBy } from '@toucan/common/services/search/types';

import { SortByOption } from '@toucan/client/features/search/config/types';
import { transformSortByToSortByOption } from '@toucan/client/features/search/helpers';

import { ControlGroup } from '../control-group';
import { ControlGroupSkeleton } from '../control-group/skeleton';

const StyledMobileSort = styled.div`
    border-left: 1px solid var(--colors-border-light);
`;

export function MobileSort({
    sortByOptions,
    onSortByChange,
    className,
    'data-testid': testId,
    sort,
    defaultSortOption,
}: {
    sortByOptions: SortByOption[];
    onSortByChange: (sortByOption: SortByOption) => void;
    className?: string;
    'data-testid'?: string;
    sort: SortBy;
    defaultSortOption: SortByOption;
}) {
    return (
        <StyledMobileSort className={`${className} control-group mobile-sort`}>
            <ControlGroupSkeleton
                data-testid={`${testId}__control-group-skeleton`}
                className="control-group-skeleton"
            />
            <ControlGroup
                data-testid={`${testId}__control-group`}
                className="control-group-content"
                options={sortByOptions}
                selectedOption={transformSortByToSortByOption({
                    sort,
                    sortOptions: sortByOptions,
                    defaultSortOption,
                })}
                onSortByChange={onSortByChange}
            />
        </StyledMobileSort>
    );
}
